/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Next_BodyInputs */

const en_wb_marketing_next_body = /** @type {(inputs: Wb_Marketing_Next_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review the form on mobile and compare traffic sources before changing the campaign.`)
};

const lv_wb_marketing_next_body = /** @type {(inputs: Wb_Marketing_Next_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pārbaudiet formu mobilajā ierīcē un salīdziniet apmeklētāju avotus, pirms maināt kampaņu.`)
};

/**
* | output |
* | --- |
* | "Review the form on mobile and compare traffic sources before changing the campaign." |
*
* @param {Wb_Marketing_Next_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_next_body = /** @type {((inputs?: Wb_Marketing_Next_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Next_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_next_body(inputs)
	return en_wb_marketing_next_body(inputs)
});